import React, { PropTypes } from 'react';
import VideoTag from '../VideoTag';
import ContentBuilder from '../../Page';

const VideoBg = ( { value: { storlek, content, style, poster, src, sources, loop }}) => {
  const size = require('styleTools/SizeClasses.scss');
  const sizeClass = (storlek && size[storlek]) || size.l;
  const styles = require('./styles.scss');

  return (
    <div className={styles.wrapper + ' ' + sizeClass} style={style} >
      <VideoTag
        value={{
          poster,
          src,
          sources,
          loop,
          className:styles.video
        }}
      />
      <ContentBuilder className="content" data={content} />
    </div>
  );

};


VideoBg.propTypes = {
  storlek: PropTypes.string,
  content: PropTypes.array,
  style: PropTypes.object,
  poster: PropTypes.string,
  src: PropTypes.string,
  sources: PropTypes.array
};

export default VideoBg;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/VideoBg/VideoBg.js
 **/